export const MESSAGE_PREVIEW_MAX_LEN = 80;

export const MESSAGES_PAGE_SIZE = 6;

export const GROUP_USERS_PAGE_SIZE = 20;

export const GROUPS_PAGE_SIZE = 20;

export interface INotificationState {
  adminGroups: INotificationGroup[];
  adminGroupsPagination: { page: number; rowsPerPage: number; rowsNumber: number };
  activeAdminGroup: INotificationGroup | undefined;
  messages: INotificationMessage[];
  messagesPagination: { page: number; rowsPerPage: number; rowsNumber: number; sortBy?: string; descending?: boolean };
  editGroup: INotificationGroup | undefined;
  isEditGroupDialogVisible: boolean;
  groupToDelete: INotificationGroup | undefined;
  isDeleteGroupDialogVisible: boolean;
  editMessage: INotificationMessage | undefined;
  isEditMessageDialogVisible: boolean;
}

export interface INotificationGroupUser {
  userId: string;
  userName: string;
  userFullName: string;
  shortUserName?: string;
  nickName?: string;
}

export interface INotificationGroup {
  id: string;
  groupName: string;
  createdAt?: string;
  createdBy?: string;
  isReadOnly?: boolean;
  totalUsers: number;
  users: INotificationGroupUser[];
}

export interface INotificationMessage {
  id: string;
  title: string;
  message: string;
  createdAt?: string;
  createdBy?: string;
  seenAt?: string | null;
  seenByTotal: number;
  seenBy: INotificationGroupUser[];
}

export const createEmptyMessage = (): INotificationMessage => ({
  id: '',
  title: '',
  message: '',
  seenByTotal: 0,
  seenBy: [],
});

export interface ISaveNotificationGroupPayload {
  idGroup: string;
  groupName: string;
  addedUsers: INotificationGroupUser[];
  removedUserIds: string[];
}

export interface IMessageFilters {
  searchText: string;
  dateFrom: string | null;
  dateTo: string | null;
}

export const createEmptyMessageFilters = (): IMessageFilters => ({
  searchText: '',
  dateFrom: null,
  dateTo: null,
});

export interface IUserLite {
  idUser: string;
  userName: string;
  fullName: string;
}
